export default {
    cannotRemoveOwnerLicense: '所有者から一般権限を外すことはできません。',
    changeToFreeLicense: '無料メンバーに変更',
    changeToFullLicense: '一般権限に変更',
    currentLicenseLimit: '付与できる一般権限数',
    distributeLicenses: '一般権限を付与',
    example: 'これは一例です',
    licenseTypeFree: '無料（閲覧のみ）',
    licenseTypeFull: '一般権限',
    memberName: 'メンバー名',
    unlimited: '無制限',
    usedLicenses: '付与されている一般権限数',
    userLicense: '利用権限',
};
